/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerFindByAssignedTo$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The user ID to filter subtasks by.
 */
  assignedTo: string;
}

export function projectSubtasksControllerFindByAssignedTo(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerFindByAssignedTo$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerFindByAssignedTo.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('assignedTo', params.assignedTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectSubtaskResponseDto>>;
    })
  );
}

projectSubtasksControllerFindByAssignedTo.PATH = '/o2-core/project-subtasks/{tenant}/assigned-to/{assignedTo}';
